import { DetailsEditor, FormContainer } from "uikit"
import React from "react"
import { Link } from "react-router-dom"
import { Button, Dropdown, Grid } from "semantic-ui-react"
import { useStore } from "store"
import { benefitTypes } from "./benefitTypes"

const getBenefitTypeOptions = ({
  people,
  incomes,
  benefits,
  isRetirementPlan
}) =>
  Object.keys(benefitTypes)
    .filter(type => {
      if (benefitTypes[type].validator === undefined) {
        return true
      }
      return benefitTypes[type].validator({ people, incomes, benefits })
    })
    .filter(type => {
      if (isRetirementPlan)
        return benefitTypes[type].worksheetType === "RetirementPlan"
      else return true
    })
    .map(benefitType => ({
      value: benefitType,
      text: benefitTypes[benefitType].label
    }))

const BenefitTypeSelectGrid = ({
  data: {
    fields: { benefitType },
    onSubmit,
    hasError,
    error
  },
  submitLabel = "Continue",
  onCancel,
  household,
  isRetirementPlan
}) => {
  const [peopleObject] = useStore("householdPeople", household.id)
  const [incomesObject] = useStore("householdIncomes", household.id)
  const [householdBenefitsObject] = useStore("householdBenefits", household.id)
  const [{ description }] = useStore(
    "contextuals",
    `Benefit: ${benefitType.value}`
  )

  const benefits = Object.values(householdBenefitsObject)
  const incomes = Object.values(incomesObject)
  const people = Object.values(peopleObject)

  return (
    <DetailsEditor heading="Add a Benefit">
      <Grid>
        <Grid.Row
          style={{
            background: "#edf7ff",
            padding: "3em",
            borderTop: "1px solid #ccc"
          }}
        >
          <Grid.Column textAlign="center">
            <Dropdown
              placeholder="Select Type of Benefit"
              data-testid="benefit_type"
              search
              selection
              options={getBenefitTypeOptions({
                people,
                incomes,
                benefits,
                isRetirementPlan
              })}
              {...benefitType}
              error={!!benefitType.error}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered style={{ minHeight: "20em" }}>
          <Grid.Column
            width={10}
            textAlign="center"
            style={{
              fontSize: "16px",
              paddingTop: "21px",
              color: "#aaa"
            }}
          >
            {benefitType.value
              ? description
              : "Please select the type of benefit you wish to add."}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
          <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
            {typeof onCancel === "string" ? (
              <Link to={onCancel}>
                <Button basic content="Cancel" primary />
              </Link>
            ) : (
              <Button basic content="Cancel" onClick={onCancel} primary />
            )}
          </Grid.Column>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button
              data-testid="continue"
              content={submitLabel}
              onClick={onSubmit}
              primary
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </DetailsEditor>
  )
}

const BenefitTypeSelector = FormContainer(
  {
    benefitType: {
      type: "string",
      required: true
    }
  },
  (fields, ...form) => {}
)(BenefitTypeSelectGrid)

export default BenefitTypeSelector
